import dynamic from "next/dynamic";
import { getServerSideProps } from "@src/domains/Stock/ssr";

import Head from "next/head";
import { StockInfoDTO } from "@src/common/types/stockInfo.type";
import { DOMINO_OG_IMAGE } from "@dominoapp/core-utils";
import {
  getMetaTagDescription,
  getMetaTagName,
} from "@src/domains/Stock/utils/metaTag";

const StockPage = dynamic(() => import("@src/domains/Stock/view"), {
  ssr: false,
});

interface StockPageProps {
  stockInfoData: StockInfoDTO;
}

const Stock = ({ stockInfoData }: StockPageProps) => {
  const ogTitle = getMetaTagName(stockInfoData);
  const ogDescription = getMetaTagDescription(stockInfoData);
  return (
    <>
      <Head>
        <title>{ogTitle} | 올인원 자산관리 도미노</title>
        <meta name="description" content={ogDescription} />
        <meta property="og:type" content="website" />
        <meta
          property="og:site_name"
          content="도미노 - 모든 투자를 관리하세요"
        />
        <meta property="og:title" content={ogTitle} />
        <meta property="og:image" content={`${DOMINO_OG_IMAGE}`} />
        <meta property="og:description" content={ogDescription} />
        <meta
          name="apple-itunes-app"
          content="app-id=1540576519, app-argument=neostock://main"
        />
        <link
          rel="icon"
          href="https://domino-web-assets.s3.ap-northeast-2.amazonaws.com/web/favicon.ico"
        />
      </Head>
      <StockPage stockInfoData={stockInfoData} />
    </>
  );
};

export { getServerSideProps };
export default Stock;
